var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7761 19.3259L37.2591 17.8428C39.7162 15.3857 43.7 15.3857 46.1572 17.8428C48.6143 20.3 48.6143 24.2838 46.1572 26.7409L44.6741 28.2239M35.7761 19.3259C35.7761 19.3259 35.9615 22.4772 38.7421 25.2579C41.5228 28.0385 44.6741 28.2239 44.6741 28.2239M35.7761 19.3259L22.1421 32.9598C21.2187 33.8833 20.7569 34.345 20.3598 34.8541C19.8914 35.4547 19.4898 36.1045 19.1621 36.792C18.8844 37.3749 18.6779 37.9944 18.2649 39.2333L16.5149 44.4833M44.6741 28.2239L31.0402 41.8579C30.1167 42.7813 29.655 43.2431 29.1459 43.6402C28.5453 44.1086 27.8955 44.5102 27.208 44.8379C26.6251 45.1156 26.0056 45.3221 24.7667 45.7351L19.5167 47.4851M19.5167 47.4851L18.2333 47.9129C17.6236 48.1161 16.9515 47.9574 16.497 47.503C16.0426 47.0485 15.8839 46.3764 16.0871 45.7667L16.5149 44.4833M19.5167 47.4851L16.5149 44.4833",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editPdf.645f15f9794bff8e60cd3898e9035156.svg";